import React from 'react';

const branches = [
  {
    name: 'Төв салбар',
    address: 'Улаанбаатар, БЗД, 13-р хороо',
    hours: '09:00-18:00',
    lat: 47.918873,
    lng: 106.917701
  },
  {
    name: 'Салбар 2',
    address: 'Улаанбаатар, СБД, 1-р хороо',
    hours: '10:00-19:00',
    lat: 47.922123,
    lng: 106.915321
  }
];

const BranchMap = () => (
  <div>
    <h2>Салбарын байршил, цагийн хувиар</h2>
    <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
      {branches.map((b, i) => (
        <div key={i} style={{ border: '1px solid #eee', borderRadius: 10, padding: 16, minWidth: 220 }}>
          <div style={{ fontWeight: 700 }}>{b.name}</div>
          <div>{b.address}</div>
          <div>Ажиллах цаг: {b.hours}</div>
          {/* Жинхэнэ газрын зураг оруулах бол Google Maps эсвэл Leaflet ашиглаж болно */}
          <div style={{ fontSize: 12, color: '#888' }}>Координат: {b.lat}, {b.lng}</div>
        </div>
      ))}
    </div>
  </div>
);

export default BranchMap;
